import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Tag } from '@/components/generals/tag'

type SectionHeadingProps = {
    tag: string
    title: ReactNode
    description?: string
    align?: 'center' | 'left'
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    tag,
    title,
    description,
    align = 'center',
    className
}): ReactNode => {
    const centered = align === 'center'

    return (
        <div
            className={cn(
                'flex w-full flex-col gap-5',
                centered ? 'items-center text-center' : 'items-start text-left',
                className
            )}
        >
            <div data-reveal='up' data-reveal-distance='24'>
                <Tag>
                    {tag}
                </Tag>
            </div>

            <h2
                data-reveal='up'
                data-reveal-delay='0.06'
                className='max-w-[18ch] font-sans text-[36px] font-normal leading-[1em] tracking-[-0.02em] text-ink tab:text-[50px] desk:text-[56px]'
            >
                {title}
            </h2>

            {description ? (
                <p
                    data-reveal='up'
                    data-reveal-delay='0.12'
                    className={cn(
                        'font-body text-[17px] leading-[1.3em] text-ink-soft',
                        centered ? 'max-w-[620px]' : 'max-w-[560px]'
                    )}
                >
                    {description}
                </p>
            ) : null}
        </div>
    )
}
